import React from 'react'
import HotPrice from '../HotelDetail/HotelPrice/HotPrice'

const SelectRooms = () => {
  return (
<></>
  )
}

export default SelectRooms